var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"received-badge"},[_c('aha-icon',{staticClass:"text-base-0",attrs:{"name":"inb","width":"12","height":"12","viewBox":"0 0 24 24"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }